import "@/App.css";
import "@/features/langflow-viewer/styles/langflow-viewer.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { RunProvider } from "@/context/RunContext";
import { AppShell } from "@/components/AppShell";
import CloseRun from "@/pages/CloseRun";
import Reconciliation from "@/pages/Reconciliation";
import CloseReadiness from "@/pages/CloseReadiness";
import CorrectiveActions from "@/pages/CorrectiveActions";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RunProvider>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<CloseRun />} />
              <Route path="/reconciliation" element={<Reconciliation />} />
              <Route path="/corrective-actions" element={<CorrectiveActions />} />
              <Route path="/close-readiness" element={<CloseReadiness />} />
            </Route>
          </Routes>
        </RunProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
